/**
 * calendar-time.pipe.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";

@Pipe({name: "calendarTime"})
export class CalendarTimePipe implements PipeTransform {

  protected format (value : moment.Moment) : string
  {
    return value.calendar();
  }

  public transform (value : number | Date) : string
  {
    if (value instanceof Date)
    {
      return this.format(moment(value));
    }
    else if (typeof value === "number")
    {
      return this.format(moment.utc(value));
    }
    else
    {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pipes/calendar-time.pipe.ts